var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"9","viewBox":"0 0 134 9"}},[_c('path',{attrs:{"fill":"#333","fill-rule":"nonzero","d":"M125 5H0V4h125V0l9 4.5-9 4.5V5z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }